/* AJOUT RAPIDE depuis la carte (lot 5 « façon Loban » — docs/superpowers/specs/2026-10-03-moola-facon-loban.md, § 4.6).
   - Produit à variante unique (sac, lunettes : bouton portant data-variante) : ajout DIRECT, /cart/add.js avec le HTML du
     panier latéral (sections), puis ouverture du tiroir panier — une seule requête.
   - Produit à pointures / tailles : feuille d'ajout rapide (window.MoolaTiroir), contenu chargé à la demande
     (GET /products/<handle>?section_id=moola-ajout-rapide, mis en cache par produit). Aucune taille pré-cochée ; sans choix,
     message « Choisissez votre pointure » (role=alert) et RIEN n'est envoyé ; après l'ajout, la feuille se ferme et le
     tiroir panier s'ouvre.
   - Échec réseau : on mène à la fiche (le parcours classique reste toujours possible).
   Délégation sur le document : les cartes ajoutées plus tard (aucune aujourd'hui) sont couvertes d'office. */
(function () {
  var feuille = document.querySelector('[data-moola-ajout-feuille]');
  var voile = document.querySelector('[data-moola-ajout-voile]');
  if (!feuille || !window.MoolaTiroir) { return; }
  var contenu = feuille.querySelector('[data-moola-ajout-contenu]');
  var chargement = contenu.innerHTML;
  var SECTION = 'moola-panier-tiroir';
  var DUREE = 420;
  var cache = new Map();
  var declencheur = null;
  [voile, feuille].forEach(function (el) { if (el.parentElement !== document.body) { document.body.appendChild(el); } });

  // Prix au format de la BOUTIQUE (shop.money_format), comme la fiche (moola-fiche.js).
  function euros(centimes, format) {
    var nombre = function (c, dec, mil, sep) { var p = (c / 100).toFixed(dec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil) + (p[1] ? sep + p[1] : ''); };
    return (format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      return ({ amount: nombre(centimes, 2, ',', '.'), amount_no_decimals: nombre(centimes, 0, ',', '.'), amount_with_comma_separator: nombre(centimes, 2, '.', ','),
        amount_no_decimals_with_comma_separator: nombre(centimes, 0, '.', ','), amount_with_space_separator: nombre(centimes, 2, ' ', ',') })[k] || nombre(centimes, 2, '.', ',');
    });
  }

  function ajouter(corps, bouton) {
    corps.sections = SECTION; corps.sections_url = window.location.pathname;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }

  function ouvrirPanier(j, origine) {
    var html = j && j.sections && j.sections[SECTION];
    if (html && window.MoolaPanier) { window.MoolaPanier.afficher(html, { ouvrir: true, declencheur: origine }); return true; }
    return false;
  }

  // ── Ajout direct (variante unique)
  function direct(bouton) {
    if (bouton.getAttribute('aria-busy') === 'true') { return; }
    bouton.setAttribute('aria-busy', 'true');
    ajouter({ items: [{ id: Number(bouton.getAttribute('data-variante')), quantity: 1 }] }, bouton)
      .then(function (x) {
        bouton.removeAttribute('aria-busy');
        if (!x.ok || !ouvrirPanier(x.j, bouton)) { window.location.href = bouton.getAttribute('data-url'); }
      })
      .catch(function () { bouton.removeAttribute('aria-busy'); window.location.href = bouton.getAttribute('data-url'); });
  }

  // ── Feuille (pointures / tailles)
  function brancher(racine, origine) {
    var form = racine.querySelector('[data-ajout-form]');
    var champ = racine.querySelector('[data-ajout-id]');
    var bouton = racine.querySelector('[data-ajout-bouton]');
    var message = racine.querySelector('[data-ajout-message]');
    var prix = racine.querySelector('[data-ajout-prix]');
    var format = racine.getAttribute('data-monnaie');
    var variantes = JSON.parse(racine.querySelector('[data-ajout-variantes]').textContent);
    var groupes = [].slice.call(racine.querySelectorAll('[data-ajout-groupe]'));
    var radios = function (g) { return [].slice.call(g.querySelectorAll('[role="radio"]')); };
    var choix = groupes.map(function (g) { var b = radios(g).find(function (x) { return x.getAttribute('aria-checked') === 'true'; }); return b ? b.getAttribute('data-valeur') : null; });
    var idx = function (g) { return Number(g.getAttribute('data-index')); };
    var correspond = function (v, sauf) { return groupes.every(function (g, i) { return i === sauf || choix[i] === null || v.options[idx(g)] === choix[i]; }); };
    function maj() {
      groupes.forEach(function (g, i) {
        radios(g).forEach(function (b) {
          var ok = variantes.some(function (v) { return v.available && v.options[idx(g)] === b.getAttribute('data-valeur') && correspond(v, i); });
          b.setAttribute('data-available', String(ok));
          if (ok) { b.removeAttribute('aria-label'); } else { b.setAttribute('aria-label', b.getAttribute('data-valeur') + ' — indisponible'); }
        });
      });
      var v = choix.every(function (c) { return c !== null; }) ? variantes.find(function (x) { return groupes.every(function (g, i) { return x.options[idx(g)] === choix[i]; }); }) : null;
      champ.value = v ? v.id : (groupes.length ? '' : champ.value);
      if (v && prix) { prix.textContent = euros(v.price, format); }
      var indispo = v && !v.available;
      bouton.disabled = !!indispo;
      bouton.textContent = indispo ? 'Indisponible' : 'Ajouter au panier';
    }
    groupes.forEach(function (g, i) {
      radios(g).forEach(function (b) {
        b.addEventListener('click', function () {
          radios(g).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); x.tabIndex = x === b ? 0 : -1; });
          choix[i] = b.getAttribute('data-valeur');
          g.querySelector('[data-ajout-choix]').textContent = choix[i];
          message.hidden = true; message.removeAttribute('role');
          maj();
        });
      });
      g.addEventListener('keydown', function (e) {
        var r = radios(g), a = r.indexOf(document.activeElement); if (a < 0) { return; }
        var n = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { n = (a + 1) % r.length; } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { n = (a - 1 + r.length) % r.length; } else { return; }
        e.preventDefault(); r[n].focus(); r[n].click();
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var manque = groupes.findIndex(function (g, i) { return choix[i] === null; });
      if (manque >= 0) {
        var nom = groupes[manque].getAttribute('data-nom');
        var bas = nom.toLowerCase();
        message.textContent = bas === 'pointure' || bas === 'taille' ? 'Choisissez votre ' + bas : 'Choisissez : ' + nom;
        message.setAttribute('role', 'alert'); message.hidden = false;
        radios(groupes[manque])[0].focus();
        return;
      }
      if (!champ.value || bouton.disabled || bouton.getAttribute('aria-busy') === 'true') { return; }
      bouton.setAttribute('aria-busy', 'true');
      ajouter({ items: [{ id: Number(champ.value), quantity: 1 }] }, bouton)
        .then(function (x) {
          bouton.removeAttribute('aria-busy');
          if (!x.ok) { message.textContent = (x.j && x.j.description) || 'Ajout impossible pour le moment.'; message.setAttribute('role', 'alert'); message.hidden = false; return; }
          window.MoolaTiroir.fermer(feuille, true);
          if (!ouvrirPanier(x.j, origine)) { window.location.href = '/cart'; }
        })
        .catch(function () { bouton.removeAttribute('aria-busy'); form.submit(); });
    });
    maj();
  }

  function ouvrirFeuille(bouton) {
    declencheur = bouton;
    var handle = bouton.getAttribute('data-handle');
    contenu.innerHTML = chargement;
    window.MoolaTiroir.ouvrir(feuille, { declencheur: bouton, voile: voile, duree: DUREE, focus: '[data-tiroir-fermer]' });
    var promesse = cache.get(handle) || fetch('/products/' + encodeURIComponent(handle) + '?section_id=moola-ajout-rapide').then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.text(); });
    cache.set(handle, promesse);
    promesse.then(function (html) {
      if (declencheur !== bouton || !window.MoolaTiroir.ouvert(feuille)) { return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var racine = doc.querySelector('[data-moola-ajout]');
      if (!racine) { throw new Error('section vide'); }
      contenu.innerHTML = '';
      contenu.appendChild(document.importNode(racine, true));
      brancher(contenu.querySelector('[data-moola-ajout]'), bouton);
      var premier = contenu.querySelector('[data-ajout-groupe] [role="radio"][aria-checked="false"]') || contenu.querySelector('[data-ajout-bouton]');
      if (premier) { premier.focus({ preventScroll: true }); }
    }).catch(function () { cache.delete(handle); window.location.href = bouton.getAttribute('data-url'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ajout-rapide]');
    if (!b) { return; }
    e.preventDefault();
    if (b.hasAttribute('data-variante')) { direct(b); } else { ouvrirFeuille(b); }
  });
})();
